<template>
  <div>
    <Header header-text="Tech preferences"></Header>
    <div class="blurb-container">
      <h1 class="blurb-title">Technologies that I use frequently</h1>
      <div class="blurb-decoration-bar"></div>
      <div>
        <div class="blurb-content">
            <img href="#" title="Debian" alt="Debian" class="techcard w3-card" src="../assets/logos/debian.svg">
            <img title="Ubuntu" alt="Ubuntu" class="techcard w3-card" src="../assets/logos/ubuntu.svg">
            <img title="Centos" alt="Centos" class="techcard w3-card" src="../assets/logos/centos.svg">
            <img title="Red Hat" alt="Red Hat" class="techcard w3-card" src="../assets/logos/red-hat.svg">
            <img title="Docker" alt="Docker" class="techcard w3-card" src="../assets/logos/docker.svg">
            <img title="GCP" alt="GCP" class="techcard w3-card" src="../assets/logos/gcp.svg">
            <img title="AWS" alt="AWS" class="techcard w3-card" src="../assets/logos/aws.svg">
            <img title="Grafana" alt="Grafana" class="techcard w3-card" src="../assets/logos/grafana.svg">
            <img title="Prometheus" alt="Prometheus" class="techcard w3-card" src="../assets/logos/prometheus.svg">
            <img title="Slack" alt="Slack" class="techcard w3-card" src="../assets/logos/slack.svg">
            <img title="Gitlab" alt="Gitlab" class="techcard w3-card" src="../assets/logos/gitlab.svg">
        </div>
      </div>
    </div>

    <div class="blurb-container">
      <h1 class="blurb-title">Technologies that I use occasionally</h1>
      <div class="blurb-decoration-bar"></div>
      <div>
        <div class="blurb-content">
          <img title="Ansible" alt="Ansible" class="techcard w3-card" src="../assets/logos/ansible2.png">
          <img title="Apache" alt="Apache" class="techcard w3-card" src="../assets/logos/apache2.png">
          <img title="Kong" alt="Kong" class="techcard w3-card" src="../assets/logos/kong.svg">
          <img title="Nginx" alt="Nginx" class="techcard w3-card" src="../assets/logos/nginx.svg">
          <img title="ServiceNow" alt="ServiceNow" class="techcard w3-card" src="../assets/logos/servicenow.svg">
          <img title="Raspberry Pi" alt="Rasbperry Pi" class="techcard w3-card" src="../assets/logos/pi.png">
        </div>
      </div>
    </div>

    <div class="blurb-container">
      <h1 class="blurb-title">Languages I am proficient with</h1>
      <div class="blurb-decoration-bar"></div>
      <div>
        <div class="blurb-content">
          <img title="Bash" alt="Bash" class="techcard w3-card" src="../assets/logos/bash.svg">
          <img title="Python" alt="Python" class="techcard w3-card" src="../assets/logos/python.svg">
          <img title="Powershell" alt="Powershell" class="techcard w3-card" src="../assets/logos/powershell.svg">
         <!-- one day  <img title="Javascript" alt="Javascript" class="techcard w3-card" src="../assets/logos/javascript.svg">-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
// @ is an alias to /src

export default {
  name: 'Home',
  components: {
    Header
  }
}
</script>
<style>
.techcard {
  height: 7em;
  width: 7em;
  padding: 1em;
  margin: 1em;
}
</style>